import { INavItem } from "../navigationComponents/solutions/MenuOptionsHelpers";

export const sortNavItemArrayByLabel = (
  navItemArray: INavItem[],
  preferredLanguage: string,
  translateFunction: any
) => {
  try {
    const collator = new Intl.Collator(preferredLanguage);
    return navItemArray.sort((firstItem, secondItem) => {
      return collator.compare(
        translateFunction(firstItem.label),
        translateFunction(secondItem.label)
      );
    });
  } catch (err) {
    console.error(err);
    return navItemArray;
  }
};
